var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundDsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      :root {\n      --primary-color: #9138b0;\n      --secondary-color: #D9B0EA;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    d: "M598.094,1668.82c49.641,45.878,86.57,93.01,112.426,134.918H925.789c-11.108-207.132-231.821-401.053-357.453-411.8-67.016,98.118-75.834,173.532,29.758,276.88",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    width: 1920,
    height: 1080,
    transform: "translate(501.99 723.738)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    d: "M467.453,1929.261c-81.638,122.914-29.152,303.567,128.5,399.565a405.79,405.79,0,0,0,40,21.458c179.783,84.016,288.455-56.336,288.455-56.336s-25.877-131.27-173.4-129.951c-103.005.9-175.872-22.474-208.736-124.726-1.754-5.41-3.3-11.206-4.75-17.135-.292-1.033-.608-2.113-.877-3.244-8.082-31.37-10.863-66.941-12.576-88.788-1.16-14.8,2.746-25.658,18.56-40.833,14.693-14.11,53.032-43.756,63.736-51.18,15.572-10.659,23.879-13.464,40.571-8.27.4.149.791.268,1.212.408-54.131-22.682-131.011,24.26-180.7,99.032",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    d: "M501.99,1803.738H800.439c-22.436-74.516-79.3-144.291-151.332-187.859a383.293,383.293,0,0,0-147.117-51.633Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    d: "M501.99,1678.953v124.785H734.653c-34.151-55.9-87-92.258-117.2-104.67-28.86-11.882-64.924-20.292-105.279-20.293q-5.046,0-10.181.178",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    d: "M598.1,1668.83c49.633,45.871,86.569,93.01,112.42,134.908h89.916c-22.436-74.516-79.3-144.291-151.332-187.859a382.339,382.339,0,0,0-122.237-47.433c11.358,31.495,34.289,64.228,71.233,100.384",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    d: "M957.236,1900.7c-32.92,3.066-70.3-17.755-93.467-48.565-25.079-33.394-40.222-12.682-40.222-12.682s19.333,105.622-71.69,180.644c-.027.021-.034.028-.071.058-16.822,13.4-46.732,35.858-59.027,45.623-58.107,48.062-106.1,105.564-104.857,201.776,0,0,46.794-42.327,166.848-90.561,222.927-89.563,227.532-264.234,202.486-276.293",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    d: "M823.527,1839.427s19.107,104.585-70.4,179.547a12.449,12.449,0,0,1-1.487,1.3c-4.591,3.72-10.942,8.614-17.776,13.827-15.324,11.834-32.516,24.874-41.105,31.679-3.168,2.617-6.276,5.257-9.378,7.924-4.929,4.33-9.785,8.694-12.356,11-.6.594-1.179,1.16-1.776,1.735,42.208,5.979,99.593-3.857,153.26-46.459,40.014-31.743,75.71-79.348,93.688-144.83.129-.489.211-.944.351-1.426-20.038-8.268-38.959-23.2-52.779-41.589-25.079-33.394-40.242-12.706-40.242-12.706",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    d: "M2197.63,723.738c39.159,84.535,121.692,147.556,224.36,172.04V723.738Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    d: "M2315.674,723.738a222.4,222.4,0,0,0,106.316,57.629V723.738Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    d: "M1716.632,723.738c1.7,129.049,52.3,242.7,132.645,322.885,0,0,136.681-58.789,156.943-260.741,2.07-20.74,4.657-41.539,8.135-62.144Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    d: "M1892.832,723.738c9.917,198.364,157.916,325.524,317.708,350.137a402.422,402.422,0,0,0,211.45-24.085v-168.9c-85.193-27.012-152.249-80.813-187.224-157.153Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    d: "M1892.834,723.738c4.034,80.649,30.9,149.519,72.087,204.51,19.481-36.657,35.334-83.369,41.3-142.366,2.07-20.74,4.657-41.539,8.135-62.144Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    d: "M2580.581,239.122c-26.285,28.743-75.38,40.185-119.981,31.653-48.319-9.268-45.126,20.789-45.126,20.789s100.5,76.818,80.515,214.334c-.006.039-.008.05-.017.106-4.06,25.009-12.366,68.282-15.358,86.535-12.624,87.936-8.954,176.1,68.321,259.031,0,0,7.3-73.975,73.818-211.112,123.524-254.649-10.776-410.651-42.172-401.336",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    transform: "translate(-501.99 -723.738)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    width: 1920,
    height: 1080,
    transform: "translate(501.99 723.738)",
    fill: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M617.9,1382.844l-96.285,17.669,8.514-37.563Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M631.982,1386.036l-111.732,20.5,1.366-6.026,96.285-17.669Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M646.063,1389.228l-127.179,23.338,1.366-6.026,111.732-20.5Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M660.143,1392.419l-142.625,26.172,1.366-6.026,127.178-23.338Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M674.224,1395.611l-158.072,29.007,1.366-6.026,142.625-26.173Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M688.3,1398.8l-173.519,31.842,1.366-6.026,158.072-29.008Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M702.386,1401.994,513.421,1436.67l1.366-6.026L688.3,1398.8Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M716.467,1405.185,512.055,1442.7l1.366-6.026,188.965-34.677Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M730.547,1408.377l-219.859,40.345,1.366-6.026,204.412-37.511Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M744.628,1411.568l-235.3,43.18,1.366-6.026,219.858-40.346Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M758.709,1414.76l-250.752,46.014,1.366-6.026,235.3-43.18Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M772.79,1417.951l-266.2,48.849,1.366-6.026,250.752-46.015Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M786.87,1421.143l-281.645,51.683,1.366-6.026,266.2-48.849Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M800.951,1424.334l-297.092,54.518,1.366-6.026,281.645-51.684Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M815.032,1427.526l-312.539,57.352,1.366-6.026,297.092-54.518Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M829.113,1430.718,501.128,1490.9l1.366-6.026,312.538-57.353Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M843.23,1433.917l-343.471,63.029,1.369-6.042,327.985-60.187Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M857.346,1437.117l-358.957,65.871,1.369-6.042,343.471-63.029Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M871.463,1440.317,497.02,1509.029l1.369-6.041,358.957-65.871Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M885.58,1443.516,495.651,1515.07l1.369-6.041,374.443-68.713Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M899.7,1446.716l-405.416,74.4,1.37-6.042,389.929-71.554Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    d: "M913.813,1449.916l-420.9,77.238,1.37-6.042,405.415-74.4Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    d: "M927.93,1453.115l-436.388,80.079,1.37-6.041,420.9-77.238Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    d: "M942.047,1456.315l-451.874,82.921,1.37-6.041,436.387-80.08Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    d: "M948.024,1457.67l.593,3.23L488.8,1545.278l1.37-6.042,451.873-82.921Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    d: "M948.617,1460.9l1.028,5.6L487.434,1551.32l1.37-6.042Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    d: "M949.645,1466.5l1.028,5.6-462.945,84.953-.713-3.886.419-1.851Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    width: 470.675,
    height: 5.696,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 487.727, 1557.054)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    width: 470.675,
    height: 5.696,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 488.755, 1562.655)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 489.783, 1568.257)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 490.811, 1573.858)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 491.839, 1579.46)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 492.867, 1585.061)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 493.895, 1590.663)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    width: 470.675,
    height: 5.696,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 494.923, 1596.264)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    width: 470.675,
    height: 5.696,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 495.951, 1601.866)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    width: 470.675,
    height: 5.696,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 496.978, 1607.468)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 498.007, 1613.069)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 499.034, 1618.671)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 500.062, 1624.272)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 501.09, 1629.874)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 502.118, 1635.475)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    width: 470.675,
    height: 5.696,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 503.146, 1641.077)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    width: 470.675,
    height: 5.696,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 504.174, 1646.678)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    width: 470.675,
    height: 5.696,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 505.202, 1652.28)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 506.23, 1657.882)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 507.258, 1663.483)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 508.286, 1669.085)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 509.314, 1674.686)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 510.342, 1680.288)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    width: 470.675,
    height: 5.696,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 511.369, 1685.889)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    width: 470.675,
    height: 5.696,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 512.397, 1691.491)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    width: 470.675,
    height: 5.696,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 513.425, 1697.092)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 514.453, 1702.694)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 515.481, 1708.296)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 516.509, 1713.897)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 517.537, 1719.499)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    width: 470.675,
    height: 5.695,
    transform: "matrix(0.984, -0.18, 0.18, 0.984, 518.565, 1725.1)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    d: "M982.538,1645.751l.691,3.763-.45,1.983-462.158,84.809-1.028-5.6Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    d: "M981.41,1657.538l-459.761,84.369-1.028-5.6L982.779,1651.5Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M980.041,1663.58l-457.364,83.929-1.028-5.6,459.761-84.368Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    d: "M978.671,1669.621,523.7,1753.11l-1.027-5.6,457.363-83.929Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M977.3,1675.663l-452.569,83.049-1.028-5.6,454.966-83.488Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M975.932,1681.7,525.76,1764.313l-1.028-5.6L977.3,1675.662Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M974.563,1687.746l-447.775,82.169-1.028-5.6L975.932,1681.7Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M973.194,1693.787l-445.377,81.729-1.028-5.6,447.774-82.169Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M971.824,1699.829l-442.98,81.289-1.028-5.6,445.377-81.73Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M970.455,1705.87l-440.583,80.849-1.028-5.6,442.98-81.289Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M969.086,1711.911,530.9,1792.321l-1.028-5.6,440.583-80.85Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M967.716,1717.953l-435.788,79.969-1.028-5.6,438.185-80.409Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    d: "M966.347,1723.994l-433.391,79.53-1.028-5.6,435.788-79.969Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    d: "M964.978,1730.036l-430.994,79.09-1.028-5.6,433.391-79.53Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    d: "M963.608,1736.077l-428.6,78.65-1.027-5.6,430.993-79.089Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    d: "M962.239,1742.119l-426.2,78.21-1.028-5.6,428.6-78.65Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    d: "M960.87,1748.16l-423.8,77.77-1.028-5.6,426.2-78.209Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    d: "M959.5,1754.2,538.1,1831.532l-1.028-5.6,423.8-77.77Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    d: "M958.131,1760.243l-419.007,76.89-1.028-5.6L959.5,1754.2Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    d: "M956.761,1766.285l-416.61,76.45-1.028-5.6,419.007-76.89Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    d: "M955.392,1772.326l-414.213,76.01-1.028-5.6,416.61-76.451Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    d: "M954.023,1778.368l-411.816,75.57-1.028-5.6,414.213-76.01Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    d: "M952.653,1784.409l-409.418,75.13-1.028-5.6,411.815-75.57Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    d: "M951.284,1790.451l-407.021,74.691-1.028-5.6,409.418-75.131Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    d: "M949.915,1796.492l-404.624,74.251-1.028-5.6,407.021-74.69Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    d: "M948.545,1802.533l-402.227,73.811-1.027-5.6,404.623-74.25Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    d: "M947.176,1808.575l-399.829,73.371-1.028-5.6,402.226-73.811Z",
    fill: "var(--primary-color)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    width: 7.628,
    height: 359.265,
    transform: "translate(441.833 1654.96) rotate(-9.005)",
    fill: "#00619b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    width: 7.628,
    height: 359.265,
    transform: "translate(449.367 1653.766) rotate(-9.005)",
    fill: "#00609a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    width: 7.628,
    height: 359.265,
    transform: "translate(456.901 1652.571) rotate(-9.005)",
    fill: "#005f9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    d: "M464.423,1651.379l1.578-.25,6.333,1.435,55.879,352.454-7.533,1.195Z",
    fill: "#005d99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    d: "M480.345,1654.38l55.4,349.444-7.534,1.194-55.879-352.454Z",
    fill: "#005c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    d: "M488.356,1656.2l54.925,346.434-7.534,1.194-55.4-349.444Z",
    fill: "#005b98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    d: "M496.366,1658.011l54.448,343.424-7.534,1.194L488.355,1656.2Z",
    fill: "#005a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    d: "M504.377,1659.827l53.97,340.413-7.533,1.2-54.448-343.424Z",
    fill: "#005996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    d: "M512.388,1661.643l53.493,337.4-7.534,1.2-53.97-340.414Z",
    fill: "#005896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    d: "M520.4,1663.458l53.016,334.393-7.534,1.195-53.493-337.4Z",
    fill: "#005795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    d: "M528.41,1665.274l52.539,331.383-7.534,1.194L520.4,1663.458Z",
    fill: "#005594"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    d: "M536.421,1667.09l52.061,328.373-7.533,1.194L528.41,1665.274Z",
    fill: "#005393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    d: "M544.432,1668.906l51.584,325.363-7.534,1.194L536.421,1667.09Z",
    fill: "#005293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    d: "M552.443,1670.721l51.107,322.353-7.534,1.194-51.584-325.363Z",
    fill: "#005192"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    d: "M560.454,1672.537l50.63,319.342-7.534,1.195-51.107-322.353Z",
    fill: "#005091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    d: "M568.464,1674.353l50.152,316.332-7.533,1.195-50.63-319.343Z",
    fill: "#004e90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    d: "M576.475,1676.169l49.675,313.322-7.533,1.194-50.153-316.332Z",
    fill: "#004d90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    d: "M584.486,1677.984l49.2,310.312-7.534,1.194-49.675-313.322Z",
    fill: "#004c8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    d: "M592.5,1679.8l48.721,307.3-7.534,1.194-49.2-310.312Z",
    fill: "#004b8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    d: "M600.508,1681.616l48.243,304.292-7.533,1.194L592.5,1679.8Z",
    fill: "#02498d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    d: "M608.519,1683.432l47.766,301.281-7.533,1.2-48.244-304.292Z",
    fill: "#06488d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    d: "M616.53,1685.247l47.289,298.271-7.534,1.195-47.766-301.282Z",
    fill: "#0a478c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    d: "M624.541,1687.063l46.812,295.261-7.534,1.2L616.53,1685.247Z",
    fill: "#0b468b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    d: "M632.552,1688.879l46.335,292.251-7.534,1.194-46.812-295.261Z",
    fill: "#10448a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    d: "M640.563,1690.695l45.857,289.241-7.533,1.194-46.335-292.251Z",
    fill: "#13438a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    d: "M648.573,1692.51l45.38,286.231-7.534,1.194-45.857-289.241Z",
    fill: "#134289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    d: "M656.584,1694.326l44.9,283.22-7.534,1.195-45.38-286.231Z",
    fill: "#174088"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    d: "M664.6,1696.142l44.426,280.21-7.534,1.195-44.9-283.221Z",
    fill: "#193f87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    d: "M672.606,1697.958l43.948,277.2-7.533,1.195L664.6,1696.142Z",
    fill: "#1a3e87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    d: "M680.617,1699.773l43.471,274.19-7.534,1.194-43.948-277.2Z",
    fill: "#1c3c86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    d: "M688.628,1701.589l42.994,271.18-7.534,1.194-43.471-274.19Z",
    fill: "#1e3b85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    d: "M696.639,1703.4l42.517,268.17-7.534,1.194-42.994-271.18Z",
    fill: "#1f3a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    d: "M704.65,1705.221l42.039,265.16-7.533,1.194L696.639,1703.4Z",
    fill: "#213884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    d: "M712.661,1707.036l41.562,262.149-7.534,1.195L704.65,1705.22Z",
    fill: "#233784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    d: "M720.671,1708.852l41.085,259.139-7.534,1.2-41.562-262.15Z",
    fill: "#243584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    d: "M728.682,1710.668l39.461,248.9-1.744,7.692-4.643.736-41.085-259.139Z",
    fill: "#253384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    d: "M736.693,1712.484l35.994,227.03-4.544,20.05-39.461-248.9Z",
    fill: "#273284"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    d: "M772.688,1939.514l-35.994-227.03,83.179,18.853Z",
    fill: "#273284"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    d: "M2419.171,939.746,2493.741,455.6l3.908.6-74.478,483.549Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    d: "M2415.17,939.746l74.664-484.753,3.908.6-74.571,484.151Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    d: "M2411.169,939.746l74.757-485.354,3.908.6L2415.17,939.746Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    d: "M2407.168,939.746l74.849-485.956,3.909.6-74.757,485.354Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    d: "M2403.167,939.746l74.942-486.558,3.908.6-74.849,485.956Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    d: "M2399.166,939.746l75.035-487.16,3.908.6-74.942,486.558Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    d: "M2395.165,939.746l75.128-487.762,3.908.6-75.035,487.16Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    d: "M2391.164,939.746l75.22-488.364,3.909.6-75.128,487.762Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    d: "M2387.163,939.746l75.313-488.966,3.908.6-75.22,488.364Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    d: "M2383.162,939.746l75.406-489.568,3.908.6-75.313,488.966Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    d: "M2379.161,939.746l75.5-490.17,3.908.6-75.4,489.568Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    d: "M2375.16,939.746l75.591-490.772,3.908.6-75.5,490.17Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    d: "M2371.159,939.746l75.684-491.374,3.908.6L2375.16,939.746Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    d: "M2367.843,939.746l-.669-.1,75.761-491.873,3.908.6-75.684,491.374Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    width: 497.673,
    height: 3.954,
    transform: "translate(2363.268 939.042) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    width: 497.673,
    height: 3.954,
    transform: "translate(2359.36 938.44) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    width: 497.673,
    height: 3.954,
    transform: "translate(2355.452 937.838) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    width: 497.673,
    height: 3.954,
    transform: "translate(2351.543 937.236) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    width: 497.673,
    height: 3.954,
    transform: "translate(2347.635 936.634) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    width: 497.673,
    height: 3.955,
    transform: "translate(2343.727 936.032) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    width: 497.673,
    height: 3.954,
    transform: "translate(2339.818 935.43) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    width: 497.673,
    height: 3.954,
    transform: "translate(2335.91 934.828) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    width: 497.673,
    height: 3.954,
    transform: "translate(2332.002 934.226) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    width: 497.673,
    height: 3.954,
    transform: "translate(2328.094 933.624) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    width: 497.673,
    height: 3.954,
    transform: "translate(2324.186 933.022) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    width: 497.673,
    height: 3.954,
    transform: "translate(2320.278 932.42) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    width: 497.673,
    height: 3.954,
    transform: "translate(2316.369 931.818) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    width: 497.673,
    height: 3.954,
    transform: "translate(2312.461 931.216) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    width: 497.673,
    height: 3.954,
    transform: "translate(2308.553 930.614) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    width: 497.673,
    height: 3.955,
    transform: "translate(2304.644 930.012) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    width: 497.673,
    height: 3.954,
    transform: "translate(2300.736 929.41) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    width: 497.673,
    height: 3.954,
    transform: "translate(2296.828 928.808) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    width: 497.673,
    height: 3.954,
    transform: "translate(2292.92 928.206) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    width: 497.673,
    height: 3.954,
    transform: "translate(2289.012 927.605) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    width: 497.673,
    height: 3.954,
    transform: "translate(2285.104 927.003) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    width: 497.673,
    height: 3.954,
    transform: "translate(2281.195 926.401) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    width: 497.673,
    height: 3.954,
    transform: "translate(2277.287 925.799) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    width: 497.673,
    height: 3.954,
    transform: "translate(2273.379 925.197) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    width: 497.673,
    height: 3.954,
    transform: "translate(2269.471 924.595) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    width: 497.673,
    height: 3.954,
    transform: "translate(2265.563 923.993) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    width: 497.673,
    height: 3.955,
    transform: "translate(2261.654 923.391) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    width: 497.673,
    height: 3.954,
    transform: "translate(2257.746 922.789) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    width: 497.673,
    height: 3.954,
    transform: "translate(2253.837 922.187) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    width: 497.673,
    height: 3.954,
    transform: "translate(2249.929 921.585) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    width: 497.673,
    height: 3.954,
    transform: "translate(2246.021 920.983) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    width: 497.673,
    height: 3.954,
    transform: "translate(2242.113 920.381) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    width: 497.673,
    height: 3.954,
    transform: "translate(2238.205 919.779) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    width: 497.673,
    height: 3.954,
    transform: "translate(2234.297 919.177) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    width: 497.673,
    height: 3.954,
    transform: "translate(2230.388 918.575) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    width: 497.673,
    height: 3.954,
    transform: "translate(2226.48 917.973) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    width: 497.673,
    height: 3.955,
    transform: "translate(2222.572 917.371) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    width: 497.673,
    height: 3.954,
    transform: "translate(2218.663 916.769) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    width: 497.673,
    height: 3.954,
    transform: "translate(2214.755 916.167) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    width: 497.673,
    height: 3.954,
    transform: "translate(2210.847 915.565) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    width: 497.673,
    height: 3.954,
    transform: "translate(2206.939 914.963) rotate(-81.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    width: 497.673,
    height: 3.954,
    transform: "translate(2203.031 914.361) rotate(-81.244)",
    fill: "var(--primary-color)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    d: "M1669.356,275.04l84.418,771.582h-84.418Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    d: "M1669.356,267.265l9.934-1.087,85.388,780.444h-10.9L1669.356,275.04Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    d: "M1679.29,266.178,1690.064,265l85.517,781.623h-10.9Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    d: "M1690.064,265l10.775-1.179,85.645,782.8h-10.9Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    d: "M1700.839,263.821l10.774-1.179,85.775,783.981h-10.9Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    d: "M1711.613,262.642l10.775-1.179,85.9,785.16h-10.9Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    d: "M1722.388,261.463l10.774-1.179,86.033,786.339h-10.9Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    d: "M1733.162,260.284l10.775-1.179,86.161,787.517h-10.9Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    d: "M1743.937,259.105l10.775-1.179,86.29,788.7h-10.9Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    d: "M1754.711,257.927l10.774-1.179,86.42,789.875H1841Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    d: "M1765.485,256.748l10.775-1.179,86.548,791.054h-10.9Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    d: "M1776.26,255.569l10.774-1.179,86.678,792.233h-10.9Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    d: "M1787.034,254.39l10.775-1.179,86.77,793.087-2.961.324h-7.907Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    width: 10.838,
    height: 797.82,
    transform: "translate(1797.802 253.212) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    width: 10.839,
    height: 797.82,
    transform: "translate(1808.58 252.033) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    width: 10.839,
    height: 797.82,
    transform: "translate(1819.355 250.854) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    width: 10.838,
    height: 797.82,
    transform: "translate(1830.126 249.676) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    width: 10.839,
    height: 797.82,
    transform: "translate(1840.904 248.496) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    width: 10.838,
    height: 797.82,
    transform: "translate(1851.675 247.318) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    width: 10.839,
    height: 797.82,
    transform: "translate(1862.453 246.139) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    width: 10.838,
    height: 797.82,
    transform: "translate(1873.224 244.96) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    width: 10.839,
    height: 797.82,
    transform: "translate(1884.002 243.781) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    width: 10.838,
    height: 797.82,
    transform: "translate(1894.772 242.603) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    width: 10.839,
    height: 797.82,
    transform: "translate(1905.551 241.423) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    width: 10.839,
    height: 797.82,
    transform: "translate(1916.325 240.244) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    width: 10.838,
    height: 797.82,
    transform: "translate(1927.096 239.066) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    width: 10.839,
    height: 797.82,
    transform: "translate(1937.874 237.887) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    width: 10.838,
    height: 797.82,
    transform: "translate(1948.645 236.709) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    width: 10.839,
    height: 797.82,
    transform: "translate(1959.423 235.529) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    width: 10.838,
    height: 797.82,
    transform: "translate(1970.194 234.351) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    width: 10.839,
    height: 797.82,
    transform: "translate(1980.972 233.171) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    width: 10.839,
    height: 797.82,
    transform: "translate(1991.747 231.993) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    width: 10.838,
    height: 797.82,
    transform: "translate(2002.517 230.814) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    width: 10.839,
    height: 797.82,
    transform: "translate(2013.296 229.635) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    width: 10.838,
    height: 797.82,
    transform: "translate(2024.066 228.457) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    width: 10.839,
    height: 797.82,
    transform: "translate(2034.845 227.277) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    width: 10.838,
    height: 797.82,
    transform: "translate(2045.615 226.099) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    width: 10.838,
    height: 797.82,
    transform: "translate(2056.39 224.92) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    width: 10.839,
    height: 797.82,
    transform: "translate(2067.168 223.741) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    width: 10.838,
    height: 797.82,
    transform: "translate(2077.939 222.563) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    width: 10.838,
    height: 797.82,
    transform: "translate(2088.713 221.384) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    width: 10.839,
    height: 797.82,
    transform: "translate(2099.491 220.204) rotate(-6.244)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    width: 10.838,
    height: 797.82,
    transform: "translate(2110.262 219.026) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    width: 10.838,
    height: 797.82,
    transform: "translate(2121.037 217.847) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    width: 10.838,
    height: 797.82,
    transform: "translate(2131.811 216.668) rotate(-6.245)",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    d: "M2142.592,215.489l21.581-2.361h340.034V978.506l-274.844,30.07Z",
    fill: "var(--primary-color)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    d: "M1859.228,309.315l136.378-2.961,17.151,789.9H1859.228Z",
    fill: "#0081bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    d: "M1995.606,306.354l4.887-.106,17.153,790.01h-4.889Z",
    fill: "#0081bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    d: "M2000.493,306.248l4.887-.106,17.155,790.116h-4.889Z",
    fill: "#0080bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    d: "M2005.379,306.142l4.887-.106,17.157,790.222h-4.889Z",
    fill: "#0080ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    d: "M2010.266,306.036l4.887-.106,17.16,790.328h-4.889Z",
    fill: "#007fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    d: "M2015.153,305.93l4.887-.106,17.162,790.434h-4.889Z",
    fill: "#007eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    d: "M2020.039,305.823l4.887-.106,17.164,790.54H2037.2Z",
    fill: "#007db7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    d: "M2024.926,305.718l4.887-.106,17.166,790.646h-4.888Z",
    fill: "#007cb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    d: "M2029.812,305.611l4.887-.106,17.169,790.752h-4.889Z",
    fill: "#007bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    d: "M2034.7,305.505l4.887-.106,17.171,790.858h-4.889Z",
    fill: "#007ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    d: "M2039.586,305.4l4.887-.106,17.173,790.964h-4.888Z",
    fill: "#0079b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    d: "M2044.472,305.293l4.886-.106,17.177,791.071h-4.889Z",
    fill: "#0078b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    d: "M2049.359,305.187l4.887-.106,17.178,791.177h-4.889Z",
    fill: "#0077b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    d: "M2054.245,305.081l4.886-.106,17.181,791.283h-4.889Z",
    fill: "#0076b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    d: "M2059.132,304.975l4.887-.106,17.183,791.389h-4.889Z",
    fill: "#0075b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    d: "M2064.019,304.869l4.886-.106,17.186,791.495H2081.2Z",
    fill: "#0074af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    d: "M2068.905,304.762l4.887-.106,17.187,791.6h-4.889Z",
    fill: "#0073ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    d: "M2073.792,304.656l4.886-.106,17.19,791.707h-4.889Z",
    fill: "#0072ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    d: "M2078.678,304.55l4.887-.106,17.192,791.813h-4.889Z",
    fill: "#0071ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    d: "M2083.565,304.444l4.886-.106,17.195,791.919h-4.889Z",
    fill: "#0070ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    d: "M2088.451,304.338l4.887-.106,17.2,792.025h-4.888Z",
    fill: "#006faa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    d: "M2093.338,304.232l4.886-.106,17.2,792.132h-4.889Z",
    fill: "#006ea9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    d: "M2098.225,304.126l4.887-.106,17.2,792.238h-4.889Z",
    fill: "#006da8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    d: "M2103.111,304.02l4.886-.106,17.2,792.344h-4.889Z",
    fill: "#006ca7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    d: "M2108,303.914l4.887-.106,17.206,792.45H2125.2Z",
    fill: "#006ba6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    d: "M2112.885,303.808l4.886-.106,17.209,792.556h-4.889Z",
    fill: "#006aa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    d: "M2117.771,303.7l.47-.01h4.419l17.208,792.566h-4.889Z",
    fill: "#0069a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    d: "M2127.549,303.691l17.209,792.566h-4.889l-17.209-792.566Z",
    fill: "#0068a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    d: "M2132.438,303.691l17.209,792.566h-4.889l-17.209-792.566Z",
    fill: "#0067a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    d: "M2137.326,303.691l17.209,792.566h-4.889l-17.209-792.566Z",
    fill: "#0066a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    d: "M2142.215,303.691l17.209,792.566h-4.889l-17.209-792.566Z",
    fill: "#0065a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    d: "M2147.1,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#00649f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    d: "M2151.993,303.691l17.208,792.566h-4.888L2147.1,303.691Z",
    fill: "#00639e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    d: "M2156.882,303.691l17.208,792.566H2169.2l-17.209-792.566Z",
    fill: "#00619e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    d: "M2161.771,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#00609d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    d: "M2166.66,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#005f9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    d: "M2171.549,303.691l17.208,792.566h-4.888L2166.66,303.691Z",
    fill: "#005e9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    d: "M2176.438,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#005d9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    d: "M2181.327,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#005c99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    d: "M2186.216,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#005b98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    d: "M2191.1,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#005a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    d: "M2195.993,303.691l17.208,792.566h-4.888L2191.1,303.691Z",
    fill: "#005996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    d: "M2200.882,303.691l17.208,792.566H2213.2l-17.209-792.566Z",
    fill: "#005895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    d: "M2205.771,303.691l17.209,792.566h-4.889l-17.209-792.566Z",
    fill: "#005794"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    d: "M2210.66,303.691l17.209,792.566h-4.889l-17.209-792.566Z",
    fill: "#005693"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    d: "M2215.549,303.691l17.209,792.566h-4.889L2210.66,303.691Z",
    fill: "#005592"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    d: "M2220.438,303.691l17.209,792.566h-4.889l-17.209-792.566Z",
    fill: "#005391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    d: "M2225.327,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#005290"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    d: "M2230.216,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#00518f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    d: "M2235.1,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#00508e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    d: "M2239.993,303.691l17.208,792.566h-4.888L2235.1,303.691Z",
    fill: "#004f8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    d: "M2244.882,303.691l17.208,792.566H2257.2l-17.209-792.566Z",
    fill: "#004e8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    d: "M2249.771,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#004d8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    d: "M2254.66,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#004c89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    d: "M2259.549,303.691l17.208,792.566h-4.888L2254.66,303.691Z",
    fill: "#004b8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    d: "M2264.438,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#004a88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    d: "M2269.327,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#044987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    d: "M2274.216,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#064886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    d: "M2279.1,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#0a4785"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    d: "M2283.993,303.691l17.209,792.566h-4.889L2279.1,303.691Z",
    fill: "#0b4684"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    d: "M2288.882,303.691l17.209,792.566H2301.2l-17.209-792.566Z",
    fill: "#0f4583"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    d: "M2293.771,303.691l17.209,792.566h-4.889l-17.209-792.566Z",
    fill: "#104483"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    d: "M2298.66,303.691l17.209,792.566h-4.889l-17.209-792.566Z",
    fill: "#134383"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    d: "M2303.549,303.691l17.208,792.566h-4.888L2298.66,303.691Z",
    fill: "#134283"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    d: "M2308.438,303.691l17.208,792.566h-4.888l-17.209-792.566Z",
    fill: "#164184"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    d: "M2328.671,303.691l17.208,792.566h-20.233l-17.208-792.566Z",
    fill: "#164184"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    d: "M2348.9,303.691l17.208,792.566H2345.88l-17.209-792.566Z",
    fill: "#154083"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    d: "M2369.137,303.691l17.208,792.566h-20.233L2348.9,303.691Z",
    fill: "#163f81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    d: "M2389.37,303.691l17.209,792.566h-20.233l-17.209-792.566Z",
    fill: "#143e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    d: "M2409.6,303.691l17.208,792.566h-20.232L2389.37,303.691Z",
    fill: "#153d80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    d: "M2429.836,303.691l17.209,792.566h-20.233L2409.6,303.691Z",
    fill: "#143c7f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundDsm);
export default __webpack_public_path__ + "static/media/backgroundDSM.53716c24777a80d485adccda93a171f1.svg";
export { ForwardRef as ReactComponent };